module.exports = __webpack_public_path__ + "static/img/empty-data.9299b8.png";